'use client'

import IconUser from '@/components/assets/icon_user.svg'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

type ViverseAvatarSize = 'XS' | 'S' | 'M' | 'L' | 'XL'

interface ViverseAvatarProps {
  size?: ViverseAvatarSize
  imageUrl?: string
  name?: string
  /** Extra classes, e.g. a responsive size override such as `md:size-25`. */
  className?: string
}

const SIZE = {
  XS: 'size-6',
  S: 'size-8.5',
  M: 'size-12',
  L: 'size-16',
  XL: 'size-25',
}

export default function ViverseAvatar({
  size = 'S',
  imageUrl = '',
  name,
  className,
}: ViverseAvatarProps) {
  return (
    <Avatar className={cn('bg-vive-primary-40 transition-all', SIZE[size], className)}>
      <AvatarImage src={imageUrl} alt={name ?? ''} className="object-cover" />
      <AvatarFallback className="bg-vive-primary-60">
        {!imageUrl ? (
          <IconUser className="bg-vive-primary-60 size-1/2" />
        ) : (
          <Skeleton className="bg-vive-primary-60 size-full" />
        )}
      </AvatarFallback>
    </Avatar>
  )
}
